import { useState } from "react";

import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

import Card from "@mui/material/Card";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import Collapse from "@mui/material/Collapse";
import Tooltip from "@mui/material/Tooltip";

import SettingsIcon from "@mui/icons-material/Settings";

export default function AdvancedControls({ view, onChange }) {
  const [open, setOpen] = useState(false);
  const isCompare = view.viewMode === "compare";

  return (
    <Card variant="outlined">
      {/* HEADER */}
      <SoftBox
        px={2}
        py={1.5}
        display="flex"
        alignItems="center"
        justifyContent="space-between"
      >
        <SoftTypography variant="h6">Flow settings</SoftTypography>

        <Tooltip title="Settings">
          <IconButton size="small" onClick={() => setOpen((v) => !v)}>
            <SettingsIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </SoftBox>

      <Collapse in={open} timeout="auto" unmountOnExit>
        <Divider />

        {/* GRID */}
        <SoftBox
          p={2.5}
          display="grid"
          gridTemplateColumns={{ xs: "1fr", md: "1fr 1fr",  xl: "1fr 1fr 1fr"}}
          columnGap={4}
          rowGap={3}
        >
          {/* METRIC */}
          <SoftBox>
            <SoftTypography variant="caption" fontWeight="bold" gutterBottom>
              Metric
            </SoftTypography>
            <Tabs
              value={view.metric}
              onChange={(_, v) => onChange({ metric: v })}
              sx={{ minHeight: 32 }}
            >
              <Tab value="ingress" label="Ingress" />
              <Tab value="egress" label="Egress" />
              <Tab value="net" label="Net" />
            </Tabs>
          </SoftBox>

          {/* GROUPING */}
          <SoftBox>
            <SoftTypography variant="caption" fontWeight="bold" gutterBottom>
              Group by
            </SoftTypography>
            <Tabs
              value={view.grouping}
              onChange={(_, v) => onChange({ grouping: v })}
              sx={{ minHeight: 32 }}
            >
              <Tab value="group" label="Area" />
              <Tab value="subgroup" label="Sub-area" />
              <Tab value="camera" label="Camera" />
            </Tabs>
          </SoftBox>

          {/* VIEW MODE */}
          <SoftBox>
            <SoftTypography variant="caption" fontWeight="bold" gutterBottom>
              View
            </SoftTypography>
            <Tabs
              value={view.viewMode}
              onChange={(_, v) => onChange({ viewMode: v })}
              sx={{ minHeight: 32 }}
            >
              <Tab value="single" label="Single" />
              <Tab value="compare" label="Compare" />
            </Tabs>
          </SoftBox>

          {/* FLOW MODE */}
          <SoftBox>
            <SoftTypography variant="caption" fontWeight="bold" gutterBottom>
              Flow mode
            </SoftTypography>
            <Tabs
              value={view.flowMode}
              onChange={(_, v) => onChange({ flowMode: v })}
              sx={{ minHeight: 32 }}
            >
              <Tab value="flow" label="Per interval" />
              <Tab value="cumulative" label="Cumulative" />
            </Tabs>
          </SoftBox>

          {/* STACK MODE */}
          <SoftBox sx={{ opacity: isCompare ? 1 : 0.45 }}>
            <SoftTypography variant="caption" fontWeight="bold" gutterBottom>
              Stack mode
            </SoftTypography>
            <Tabs
              value={view.stacked ? "stacked" : "overlap"}
              onChange={(_, v) => onChange({ stacked: v === "stacked" })}
            >
              <Tab value="stacked" label="Stacked" disabled={!isCompare} />
              <Tab value="overlap" label="Overlap" disabled={!isCompare} />
            </Tabs>
          </SoftBox>

          {/* TOTAL LINE */}
          <SoftBox sx={{ opacity: isCompare ? 1 : 0.45 }}>
            <SoftTypography variant="caption" fontWeight="bold" gutterBottom>
              Total line
            </SoftTypography>
            <Tabs
              value={view.showTotal ? "on" : "off"}
              onChange={(_, v) => onChange({ showTotal: v === "on" })}
            >
              <Tab value="on" label="On" disabled={!isCompare} />
              <Tab value="off" label="Off" disabled={!isCompare} />
            </Tabs>
          </SoftBox>
        </SoftBox>
      </Collapse>
    </Card>
  );
}
